import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "text-subtitle2"
};
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "self-center text-weight-bold" };
const _hoisted_4 = { class: "pl-xxs" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_generic_options = _resolveComponent("generic-options");
    const _component_q_list = _resolveComponent("q-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_badge = _resolveComponent("q-badge");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_item_section = _resolveComponent("q-item-section");
    const _component_q_expansion_item = _resolveComponent("q-expansion-item");
    const _component_q_separator = _resolveComponent("q-separator");
    return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedDrawerOptions, (optionVal) => {
        return (_openBlock(), _createElementBlock("div", {
            key: optionVal.category
        }, [
            (((_ctx.isOuter && optionVal.showOnOuter) || !_ctx.isOuter) && optionVal.show && (optionVal.type === 'route'))
                ? (_openBlock(), _createBlock(_component_generic_options, _mergeProps({
                    key: 0,
                    ref_for: true
                }, optionVal, {
                    "icon-right": _ctx.iconRight,
                    "icon-size": _ctx.iconSize
                }), null, 16, ["icon-right", "icon-size"]))
                : (((_ctx.isOuter && optionVal.showOnOuter) || !_ctx.isOuter) && optionVal.show && (optionVal.type === 'list'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_q_card, { flat: "" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_card_section, { class: "q-pa-none" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_q_list, null, {
                                            default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionVal.items, (value, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: value.title
                                                    }, [
                                                        (value.showCondition)
                                                            ? (_openBlock(), _createBlock(_component_generic_options, _mergeProps({
                                                                key: 0,
                                                                ref_for: true
                                                            }, value, {
                                                                "badge-count": value.badgeCount,
                                                                "icon-right": _ctx.iconRight,
                                                                "icon-size": _ctx.iconSize,
                                                                "show-separator": index < (optionVal.shownLen - 1)
                                                            }), null, 16, ["badge-count", "icon-right", "icon-size", "show-separator"]))
                                                            : _createCommentVNode("", true)
                                                    ]));
                                                }), 128))
                                            ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                    _: 2
                                }, 1024)
                            ]),
                            _: 2
                        }, 1024)
                    ]))
                    : (((_ctx.isOuter && optionVal.showOnOuter) || !_ctx.isOuter) && optionVal.show && (optionVal.type === 'expand'))
                        ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                            key: 2,
                            "default-opened": optionVal.defaultOpened,
                            "header-class": "text-subtitle2"
                        }, {
                            header: _withCtx(() => [
                                _withDirectives(_createVNode(_component_q_item_section, { avatar: "" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_q_btn, {
                                            round: "",
                                            flat: "",
                                            dense: "",
                                            unelevated: "",
                                            name: optionVal.title,
                                            icon: optionVal.icon,
                                            size: _ctx.iconSize
                                        }, {
                                            default: _withCtx(() => [
                                                (optionVal.badgeCount > 0)
                                                    ? (_openBlock(), _createBlock(_component_q_badge, {
                                                        key: 0,
                                                        color: "red",
                                                        floating: ""
                                                    }))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                        }, 1032, ["name", "icon", "size"])
                                    ]),
                                    _: 2
                                }, 1536), [
                                    [_vShow, !_ctx.iconRight]
                                ]),
                                _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_2, [
                                            _createElementVNode("div", _hoisted_3, _toDisplayString(optionVal.title), 1),
                                            _withDirectives(_createElementVNode("div", _hoisted_4, _cache[0] || (_cache[0] = [
                                                _createElementVNode("div", { class: "bg-red st-wh-12 st-ht-12 rounded" }, null, -1)
                                            ]), 512), [
                                                [_vShow, _ctx.iconRight && optionVal.badgeCount > 0]
                                            ])
                                        ])
                                    ]),
                                    _: 2
                                }, 1024)
                            ]),
                            default: _withCtx(() => [
                                _createVNode(_component_q_card, { flat: "" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_q_card_section, { class: "q-py-none" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_q_list, null, {
                                                    default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionVal.items, (value, index) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: value.title
                                                            }, [
                                                                (value.showCondition)
                                                                    ? (_openBlock(), _createBlock(_component_generic_options, _mergeProps({
                                                                        key: 0,
                                                                        ref_for: true
                                                                    }, value, {
                                                                        "badge-count": value.badgeCount,
                                                                        "icon-right": _ctx.iconRight,
                                                                        "icon-size": _ctx.iconSize,
                                                                        "show-separator": index < (optionVal.shownLen - 1),
                                                                        onClick: _ctx.customRoute
                                                                    }), null, 16, ["badge-count", "icon-right", "icon-size", "show-separator", "onClick"]))
                                                                    : _createCommentVNode("", true)
                                                            ]));
                                                        }), 128))
                                                    ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                    _: 2
                                }, 1024)
                            ]),
                            _: 2
                        }, 1032, ["default-opened"]))
                        : _createCommentVNode("", true),
            (((_ctx.isOuter && optionVal.showOnOuter) || !_ctx.isOuter) && optionVal.show)
                ? (_openBlock(), _createBlock(_component_q_separator, { key: 3 }))
                : _createCommentVNode("", true)
        ]));
    }), 128));
}
